import { render, staticRenderFns } from "./Lists.vue?vue&type=template&id=435bdac4&"
import script from "./Lists.vue?vue&type=script&lang=ts&"
export * from "./Lists.vue?vue&type=script&lang=ts&"
import style0 from "./Lists.vue?vue&type=style&index=0&id=435bdac4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports